import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function DemoPage() {
  const navigate = useNavigate();

  useEffect(() => {
    // デモ教師として自動ログイン
    fetch('/api/auth/teacher/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ login_id: 'demo-teacher', password: 'password' })
    })
      .then(r => r.json())
      .then(data => {
        if (data.token) {
          localStorage.setItem('token', data.token);
          localStorage.setItem('role', 'teacher');
          localStorage.setItem('userInfo', JSON.stringify(data));
          localStorage.setItem('isDemo', 'true');
          navigate('/teacher');
        }
      })
      .catch(() => navigate('/login'));
  }, [navigate]);

  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      height: '100vh', background: '#f0f4ff', flexDirection: 'column', gap: 16
    }}>
      <div style={{ fontSize: 48 }}>🐸</div>
      <div style={{ fontSize: 18, fontWeight: 'bold', color: '#2d4a8a' }}>ふりカエル 体験版</div>
      <div style={{ fontSize: 14, color: '#666' }}>体験環境を準備しています...</div>
      <div style={{ width: 200, height: 6, background: '#e2e8f0', borderRadius: 99, overflow: 'hidden' }}>
        <div style={{ width: '60%', height: '100%', background: '#2d4a8a', borderRadius: 99, animation: 'none' }} />
      </div>
    </div>
  );
}
